import { useCallback, useEffect, useState } from 'react';
import { TrelloStorage } from '@trello/storage';

export function useSnooze(snoozeKey: string, snoozeSeconds: number) {
  const [isSnoozed, setSnoozed] = useState(false);

  const checkSnoozed = useCallback(() => {
    let shouldBeSnoozed = false;
    const storageItem = TrelloStorage.get(snoozeKey);
    if (storageItem) {
      const snoozeMilliseconds = snoozeSeconds * 1000;
      const snoozedAt = parseInt(storageItem);
      if (
        snoozeMilliseconds &&
        snoozedAt &&
        snoozedAt + snoozeMilliseconds > Date.now()
      ) {
        shouldBeSnoozed = true;
        // check again after the snooze expires
        setTimeout(() => {
          checkSnoozed();
        }, snoozeMilliseconds + 1000);
      } else {
        // if the value has expired, or snoozing is disabled, remove the storage key
        TrelloStorage.unset(snoozeKey);
      }
    }
    setSnoozed(shouldBeSnoozed);
  }, [snoozeKey, snoozeSeconds]);

  useEffect(() => {
    checkSnoozed();
  }, [checkSnoozed]);

  const snooze = useCallback(() => {
    if (snoozeSeconds > 0) {
      TrelloStorage.set(snoozeKey, Date.now().toString());
      checkSnoozed();
    }
  }, [snoozeKey, snoozeSeconds, checkSnoozed]);

  return { isSnoozed, snooze };
}
